module.exports = __webpack_public_path__ + "static/week_week4_spot6-8671da31766f59aeac545d959402b8e2.jpg";